import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub/';
import Modal from "components/Modal";
import { withRouter } from 'react-router-dom'
import Error500 from "components/Error500";
import style from './style.scss'; //NOSONAR

let actions = [];

const ModalError = () => {

    useEffect(() => {
        actions.push(PubSub.register('error_503', _errorOpen));

        return function cleanup() {
            actions = actions.map(token => PubSub.unregister(token));
            actions = [];
        };
    }, []);

    const _errorOpen = () => {
        //modal.current.openModal();
        /* eslint-disable no-console */
        console.error('Error 500');
    }

    return (
        <Modal customClass='modal-error-503' actionOpen='error_503_open' actionClose="error_503_close">
            <Error500 />
        </Modal>
    )
}

ModalError.propTypes = {
    history: PropTypes.object
};

export default withRouter(ModalError);



